import React, { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import API_BASE_URL from "../config";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    if (!token) {
      setStatus("error");
      setMessage("No token provided");
      return;
    }

    const verify = async () => {
      try {
        const res = await fetch(`${API_BASE_URL}/verify-email?token=${encodeURIComponent(token)}`);
        const text = await res.text();
        if (!res.ok) {
          setStatus("error");
          setMessage(text || "Verification failed");
        } else {
          setStatus("success");
          setMessage(text || "Email verified successfully");
          setTimeout(() => navigate("/login"), 3000);
        }
      } catch (err) {
        setStatus("error");
        setMessage(err?.message || String(err));
      }
    };

    verify();
  }, [token, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4 py-10">
      <div className="max-w-xl w-full bg-white dark:bg-gray-800 rounded-2xl shadow-lg p-8">
        {status === "verifying" && <p className="text-center">Verifying your email...</p>}
        {status === "success" && (
          <div>
            <h2 className="text-2xl font-bold text-center text-green-600 mb-4">Verified</h2>
            <p className="text-center">{message}</p>
            <p className="text-center mt-4 text-gray-600">Redirecting to login...</p>
          </div>
        )}
        {status === "error" && (
          <div>
            <h2 className="text-2xl font-bold text-center text-red-600 mb-4">Verification Failed</h2>
            <p className="text-center">{message}</p>
          </div>
        )}
      </div>
    </div>
  );
}
